<template>
  <div class="container hearing-test">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-wrapper">
          <h2 class="title">Hearing Test</h2>
        </div>
        <p class="subtitle">press the button every time you hear a tone</p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="rect-wrapper mb-3">
          <div class="row d-flex justify-content-center align-items-center">
            <div
              class="col-sm-12 col-md-12 col-lg-5 d-flex justify-content-center align-items-center"
            >
              <div class="rect-left">
                <div
                  v-for="dash in 7"
                  :class="{active: i + 2 > dash && !rightEar, testing: dash === i + 1 && !rightEar && running}"
                  class="rect"
                ></div>
                <div :class="{active: !rightEar}" class="left-side"><span>L</span></div>
              </div>
            </div>
            <div class="vertical-divider"></div>
            <div
              class="col-sm-12 col-md-12 col-lg-5 d-flex justify-content-center align-items-center"
            >
              <div class="rect-right">
                <div :class="{active: rightEar}" class="right-side"><span>R</span></div>
                <div
                  v-for="dash in 7"
                  :class="{active: i + 2> dash && rightEar, testing: dash === i + 1 && rightEar && running}"
                  class="rect"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="image-wrapper mb-3">
          <img v-show="!rightEar" src="/img/headsetL.svg" alt="headset-left"/>
          <img v-show="rightEar" src="/img/headsetR.png" alt="headset-right"/>
          <div @click="onTap()" class="button-wrapper">
            <div class="button-top"></div>
            <div class="button-middle"><span>{{ complete ? 'Done' : (running ? 'Press' : 'Start')}}</span></div>
            <div class="button-bottom"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!complete" class="row">
      <div class="col-sm-12">
        <div class="description-wrapper">
          <p>
            you are now listening a
            <span :class="rightEar ? 'right' : 'left'" class="position">{{rightEar ? 'right' : 'left'}}</span>
            ear signal
          </p>
        </div>
      </div>
    </div>
    <div v-show="complete" class="row">
      <div class="col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
        <div class="button-wrapper">
          <router-link to="/login" class="button-main">View results</router-link>
          <a @click.prevent="restart()" href="" class="button-minor">Restart hearing test</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {maxAtt, tones, startAtt} from "../constants";

export default {
    data() {
      return {
        audioPlayer: null,
        timer: null,

        incFact: 5,
        decFact: 10,

        // Create the tones array with all the frequency
        tones,
        running: false,
        found: false,
        heard: false,
        repeatNumber: 0,
        i: 0,

        // Declare prev variable to zero: it will become +1 if the previous tone had higer volume or -1 if the previous tone had lower volume
        prev: 0,
        currentAtt: 0,
        resL: [],
        resR: [],
        rightEar: false,
        complete: false,
        startAtt
      }

    },
    methods: {
      onTap() {
        if (this.running) {
          this.heard = true
          this.startTimer()
        } else {
          this.running = true
          this.startHT()
        }
      },
      async startTimer() {
        if (this.complete) return

        this.timer && clearTimeout(this.timer)
        this.timer = null
        if (this.audioPlayer !== null) {
          this.audioPlayer.pause()
          this.audioPlayer.currentTime = 0
        }

        if (this.currentAtt <= maxAtt[this.i] && this.heard) {
          if (!this.rightEar) {
            this.resL[this.i] = maxAtt[this.i]
          } else {
            this.resR[this.i] = maxAtt[this.i]
          }
          this.found = true
          this.repeatNumber = 0
        } else if (this.repeatNumber === 2 && this.currentAtt >= 0) {
          if (!this.rightEar) {
            this.resL[this.i] = 0
          } else {
            this.resR[this.i] = 0
          }
          this.found = true
          this.repeatNumber = 0
        } else if (this.heard) {
          if (this.prev === -1) {
            this.found = true
            this.prev = 0
          }
          this.heard = false
          if (!this.rightEar) {
            this.resL[this.i] = this.currentAtt
          } else {
            this.resR[this.i] = this.currentAtt
          }
          this.repeatNumber = 0
          this.currentAtt = this.currentAtt - 10
          this.prev = 1
        } else if (!this.heard && this.repeatNumber === 2) {
          this.prev = -1
          this.currentAtt = this.currentAtt + 5
          this.repeatNumber = 0
        }

        if (this.found) {
          this.i += 1
          if (this.i < this.tones.length) {
            this.currentAtt = this.startAtt[this.i]
          } else if (this.rightEar) {
            this.running = false
            this.done()
            return
          } else {
            this.i = 0
            this.rightEar = true
            this.currentAtt = this.startAtt[this.i]
          }
          this.found = false
          this.heard = false
          this.prev = 0
          this.repeatNumber = 0
        }

        let tone = this.tones[this.i]
        let side = this.rightEar ? 'right' : 'left'

        let selectedSoundFileName = `audio/${tone}${this.currentAtt}dB-${side}.mp3`
        console.log(this.i)
        console.log(`Repeat number ${this.repeatNumber}`)
        try {
          console.log(selectedSoundFileName)
          // reuse same audio player
          if (this.audioPlayer !== null) {
            this.audioPlayer.setAttribute('src', selectedSoundFileName)
            this.audioPlayer.load();
          } else {
            this.audioPlayer = new Audio(selectedSoundFileName);
          }
          this.audioPlayer.oncanplay = () => {
            this.audioPlayer.play()
          }

          this.audioPlayer.onloadedmetadata = () => {
            this.timer = setTimeout(this.startTimer, (this.audioPlayer.duration * 1000) + 1000);
          }

          console.log("currAtt: " + String(this.currentAtt))
          this.repeatNumber += 1

        } catch (error) {
          console.log(error)
        }
      },
      startHT() {
        this.resetHT()
        this.startTimer()
        this.resetHT()
        this.startTimer()
      },
      resetHT() {
        this.resL = []
        this.resR = []
        this.i = 0

        if (this.audioPlayer !== null) {
          this.audioPlayer.pause()
          this.audioPlayer.currentTime = 0
        }
        this.timer && clearTimeout(this.timer)
        this.timer = null

        this.rightEar = false
        this.found = false
        this.repeatNumber = 0
        this.prev = 0
        this.currentAtt = this.startAtt[0]
      },
      done() {
        this.timer && clearTimeout(this.timer)
        this.timer = null
        this.complete = true

        this.$store.commit('setResults', {
          originalL: this.resL,
          originalR: this.resR
        })
      },

      restart() {
        this.complete = false
      }
    },
    destroyed() {
      this.resetHT()
    }
  }
</script>
